import { render, staticRenderFns } from "./ModalTariffListForm.vue?vue&type=template&id=12379876"
import script from "./ModalTariffListForm.js?vue&type=script&lang=js&external"
export * from "./ModalTariffListForm.js?vue&type=script&lang=js&external"
import style0 from "./ModalTariffListForm.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports